import { useState } from 'react'
import { useTranslation } from 'libs/i18n'
import { useForm } from 'libs/form'
import { ColorPicker } from 'shared/components'
import { InputGroup } from 'shared/molecules'
import { Field, fieldButtonClassName } from '../Field'
import { Position, usePlacement } from '../../placement'
import { useRectangleValidationSchema } from './hooks/useRectangleValidationSchema'

type RectangleProps = {
	floormapConfig: any[]
	onSubmit: (data: any) => void
}

export const Rectangle = ({ floormapConfig, onSubmit }: RectangleProps) => {
	const { t } = useTranslation()
	const [color, setColor] = useState('#BBBBBB')
	const validationResolver = useRectangleValidationSchema()

	const {
		handleSubmit,
		register,
		formState: { errors }
	} = useForm({
		resolver: validationResolver,
		mode: 'onChange'
	})

	const submitRectangle = (
		{ width, height, label }: any,
		position: Position = { x: 45, y: 70 }
	) => {
		onSubmit([
			...floormapConfig,
			{
				type: 'rect',
				...position,
				width: +width,
				height: +height,
				fill: color,
				...(label?.trim() && { label: label.trim() }),
				draggable: true,
				id: crypto.randomUUID()
			}
		])
	}

	usePlacement('rect', (position) => handleSubmit((data) => submitRectangle(data, position))())

	return (
		<Field label={t('Rectangle')} section="rect" isPlaceable>
			<form className="space-y-2" onSubmit={handleSubmit((data) => submitRectangle(data))}>
				<InputGroup
					id="floor-map-rectangle-label"
					label={t('Label')}
					placeholder={t('e.g. WC')}
					{...register('label')}
				/>
				<InputGroup
					id="floor-map-rectangle-width"
					label={t('Width')}
					placeholder={t('width (px)')}
					{...register('width')}
					error={(errors as any).width}
				/>
				<InputGroup
					id="floor-map-rectangle-height"
					label={t('Height')}
					placeholder={t('height (px)')}
					{...register('height')}
					error={(errors as any).height}
				/>
				<ColorPicker
					id="floor-map-rectangle-color"
					label={t('Color')}
					color={color}
					onChange={({ hex }) => setColor(hex)}
				/>
				<button type="submit" className={fieldButtonClassName}>
					{t('Add rectangle')}
				</button>
			</form>
		</Field>
	)
}
